export enum QueryParams {
    PosPlatform = 'pos_platform',
}
